export const InterceptionTitle = ({ count }: { count: number }) => {
  return (
    <div className="d-flex flex-column gap-3">
      <div className="fw-bold">Intersección {count}</div>
      <div className="small">Polígono más importante:</div>
    </div>
  );
};
